import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AudioPlayer } from "./components/AudioPlayer";
import Index from "./pages/Index";
import DonationSuccess from "./pages/DonationSuccess";
import InsiderVideo from "./pages/InsiderVideo";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import TheFilm from "./pages/TheFilm";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TooltipProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/the-film" element={<TheFilm />} />
            <Route path="/donation-success" element={<DonationSuccess />} />
            <Route path="/insider-video" element={<InsiderVideo />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <AudioPlayer />
          <Toaster />
          <Sonner />
        </TooltipProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;